import {
  MobilePackageDetails,
  MobilePackageDisplayType,
} from '../shared/components/large-mobile-package/large-mobile-package.interfaces';
import { IMobileServiceBoundDevice } from '../modules/mobile-services/mobile-services.interface';

export const SHARED_MOBILE_PACKAGES: MobilePackageDetails[] = [
  {
    newPackageDisplayMode: true,
    size: '50 GB',
    price: 6890,
    details: '',
    extraDetail: 'Korlátlan belföldi beszélgetés',
    crmIdentifier: '110083834',
    loyaltyMonth: 10,
    view: false,
    isBarlow: true,
    extra50gb: false,
    packageDisplayType: MobilePackageDisplayType.RED_BASED_WITH_WHITE,
    pillConfiguration: {
      row1: {
        text: '6890',
        color: '#fff',
      },
      row2: {
        text: 'Korlátlan',
        color: '#fff',
      },
      row3: {
        text: '50 GB',
        color: '#fff',
      },
      sccClass: 'three-with-price',
      icon: {
        url: 'assets/images/ajandek-fulhallgato-csomaghoz-10ft.svg',
        size: {
          width: '85px',
          height: 'auto',
        },
        position: {
          top: '5px',
          left: '-10px',
          position: 'relative',
        },
      },
    },
    customIcons: {
      firstIcon: 'assets/images/akcio_arga_feher_felirat_szeles.svg',
      secondIcon: {
        url: 'assets/images/ajandek-fulhallgato-csomaghoz-10ft.svg',
        size: {
          width: '140px',
          height: 'auto',
        },
        position: {
          left: '200px',
        },
      },
    },
  },
  {
    newPackageDisplayMode: true,
    size: '100 GB',
    price: 5790,
    details: '',
    extraDetail: '100 perc belföldi beszélgetés',
    crmIdentifier: '110083830',
    loyaltyMonth: 10,
    view: false,
    isBarlow: true,
    packageDisplayType: MobilePackageDisplayType.RED_BASED_WITH_WHITE,
    pillConfiguration: {
      row1: {
        text: '100 perc',
        color: '#fff',
      },
      row2: {
        text: '100 GB',
        color: '#fff',
      },
      sccClass: 'two',
    },
    customIcons: {
      firstIcon: 'assets/images/akcio_arga_feher_felirat_szeles.svg',
    },
  },
  {
    newPackageDisplayMode: true,
    size: '100 GB',
    price: 7890,
    details: '',
    extraDetail: 'Korlátlan belföldi beszélgetés',
    crmIdentifier: '110083835',
    loyaltyMonth: 10,
    view: false,
    isBarlow: true,
    packageDisplayType: MobilePackageDisplayType.RED_BASED_WITH_WHITE,
    pillConfiguration: {
      row1: {
        text: '7890',
        color: '#fff',
      },
      row2: {
        text: 'Korlátlan',
        color: '#fff',
      },
      row3: {
        text: '100 GB',
        color: '#fff',
      },
      sccClass: 'three-with-price',
      icon: {
        url: 'assets/images/ajandek-fulhallgato-csomaghoz-10ft.svg',
        size: {
          width: '85px',
          height: 'auto',
        },
        position: {
          top: '5px',
          left: '-10px',
          position: 'relative',
        },
      },
    },
    customIcons: {
      firstIcon: 'assets/images/akcio_arga_feher_felirat_szeles.svg',
      secondIcon: {
        url: 'assets/images/ajandek-fulhallgato-csomaghoz-10ft.svg',
        size: {
          width: '140px',
          height: 'auto',
        },
        position: {
          left: '200px',
        },
      },
    },
  },
];

export const SERVICES_WITH_BOUND_DEVICE: IMobileServiceBoundDevice[] = [
  {
    serviceCrmId: 110083834,
    boundDevice: {
      deviceName: 'Canyon CNS-TWS5W bluetooth fülhallgató',
      deviceColor: 'fehér',
    },
  },
  {
    serviceCrmId: 110083835,
    boundDevice: {
      deviceName: 'Canyon CNS-TWS5W bluetooth fülhallgató',
      deviceColor: 'fehér',
    },
  },
];
